import { DatePicker, Select, TableColumnsType } from 'antd';
import {
  JobRFQAdjustPayload,
  JobRFQShippingAccountServices,
  JobRFQShippingItemViewer,
  ShippingAccountTypeEnum,
} from 'domains/jobconfigDomain';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { addressTranslator } from 'utils/address';
import { SHIPPING_SPECIAL_DELIVERY, SHIPPING_WILL_CALL,SHIPPING_SUPPLIER_DELIVERY } from 'utils/constants';
import { formatNumberToThousandths } from 'utils/number';
import {
  DEFAULT_DATE_FORMAT,
  RFQ_SHIPPING_DATE_FORMAT_LOCAL,
  RevxDate,
} from '../RevxDate';
import { RevxInputNumber } from '../RevxInputNumber';
import { RevxMoney } from '../RevxMoney';
import RevxTable from '../RevxTable';
import './index.less';

type Props = {
  disabled?: boolean;
  isJobConfig?: boolean;
  shippingItems: Array<JobRFQShippingItemViewer>;
  quantity: number;
  quantityIndex: number;
  orgId: number;
  qtySerialNumber: number;
  rfqId?: number | string;
  shipmentMethodChangeHandler?: (
    payload: Partial<JobRFQAdjustPayload>
  ) => Promise<'success' | 'error'>;
};
interface ShippingColumnsType extends JobRFQShippingItemViewer {
  serialNumber: number;
  address: string;
  methods: Array<JobRFQShippingAccountServices & { key: number }>;
  arrivalDate: string;
  costs: number;
}
const RevxSupplierShippingMethodTable = ({
  isJobConfig,
  disabled,
  shippingItems,
  quantity,
  quantityIndex,
  orgId,
  qtySerialNumber,
  rfqId,
  shipmentMethodChangeHandler,
}: Props) => {
  const [resource, setResource] = useState<ShippingColumnsType[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const shippingTitle =
    shippingItems?.length > 1 ? 'Split Shipping' : 'Shipping';

  useEffect(() => {
    let shippingAccountsMap: {
      [index: string]: (JobRFQShippingAccountServices & { key: number })[];
    } = {};
    (async () => {
      if (shippingItems) {
        const data: ShippingColumnsType[] = shippingItems.map((i, id) => {
          const {
            shippingInfo,
            estimatedDeliveryTime,
            serialNumber,
            shippingCost,
          } = i;
          return {
            address: addressTranslator.dataToAddress(shippingInfo),
            methods: shippingAccountsMap[serialNumber],
            arrivalDate: estimatedDeliveryTime,
            costs: shippingCost,
            ...i,
          };
        });
        setResource(data);
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingItems]);

  /*  const getShippingAccountList = async (
    accountType: ShippingAccountTypeEnum
  ) => {
    try {
      if (rfqId) {
        const data = await workspaceService.switchRfqJobShippingAccount({
          rfqId,
          orgId,
          qtySerialNumber,
          accountType: accountType,
        });
        data.forEach((i) => {
          shippingAccountList.current[i.serialNumber] = i.services
            .filter(
              (v) => !v.rush && v.carrierType !== CarrierTypeEnum.Nonstandard
            )
            .map((u, key) => {
              return { ...u, key };
            });
        });
      }
    } catch {
      setLoading(false);
    }
  };*/

  const otherPayload = (serialNumber: number): any => {
    return (resource || [])
      .filter((item) => item.serialNumber !== serialNumber)
      .map((item) => {
        return {
          serialNumber: item.serialNumber,
          // carrierService: item.shippingInfo.carrierService,
          // shipmentType: item.shippingInfo.shipmentType,
          // carrierType: item.shippingInfo.carrierType,
          charge: isJobConfig ? item.revxFreightCharge : item.freightCost,
          // readyDate: item?.readyDate || item?.suggestReadyDate,
        };
      });
  };

  const columns: TableColumnsType<ShippingColumnsType> = [
    {
      title: 'Shipping Address',
      dataIndex: 'address',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      render: (v) => {
        return formatNumberToThousandths(v);
      },
    },
    {
      title: 'Ready Date',
      dataIndex: 'readyDate',
      render: (v) => {
        return <RevxDate dateStr={v} />;
      },
    },
    {
      title: 'Arrival Date',
      dataIndex: 'deliveryDate',
      render: (v) => {
        return <RevxDate dateStr={v} />;
      },
    },
    // {
    //   title: 'Ready Date',
    //   dataIndex: 'methods',
    //   render: (value: ShippingColumnsType['methods'], record, index) => {
    //     // const selectedSvc = value?.find((i) => i.selected);
    //     const isSpecialDelivery =
    //       SHIPPING_SPECIAL_DELIVERY === record.shippingInfo.carrierService;
    //     return (
    //       <>
    //         {isSourcer || (!isSourcer && isSpecialDelivery) ? (
    //           <DatePicker
    //             size="small"
    //             disabled={isSourcerPayerValue}
    //             defaultValue={moment(
    //               record?.readyDate || record?.suggestReadyDate,
    //               moment.ISO_8601
    //             )}
    //             format={DEFAULT_DATE_FORMAT}
    //             disabledDate={(d) =>
    //               d &&
    //               (Boolean(record.orderDate && d < moment(record.orderDate)) ||
    //                 Boolean(
    //                   record.expectedDeliveryDate &&
    //                   d > moment(record.expectedDeliveryDate)
    //                 ))
    //             }
    //             onChange={(e) => {
    //               if (typeof shipmentMethodChangeHandler === 'function') {
    //                 shipmentMethodChangeHandler({
    //                   id: rfqId || 0,
    //                   orgId,
    //                   qtySerialNumber,
    //                   body: {
    //                     shippingAdjusts: [
    //                       {
    //                         serialNumber: record.serialNumber,
    //                         // carrierService: selectedSvc?.serviceName,
    //                         // shipmentType: selectedSvc?.shipmentType,
    //                         // carrierType: selectedSvc?.carrierType,
    //                         readyDate: moment(e).format(
    //                           RFQ_SHIPPING_DATE_FORMAT_LOCAL
    //                         ),
    //                       },
    //                       ...otherPayload(record.serialNumber),
    //                     ],
    //                   },
    //                 });
    //               }
    //             }}
    //           />
    //         ) : (
    //           <RevxDate
    //             dateStr={moment(
    //               record?.readyDate || record?.suggestReadyDate,
    //               moment.ISO_8601
    //             )}
    //           />
    //         )}
    //       </>
    //     );
    //   },
    // },
    {
      title: 'Shipment Method',
      dataIndex: 'methods',
      render: (value: ShippingColumnsType['methods'], record, index) => {
        let defaultValue = 0;
        const isSpecialDelivery =
          SHIPPING_SPECIAL_DELIVERY === record.shippingInfo.carrierService ||
          SHIPPING_SUPPLIER_DELIVERY === record.shippingInfo.carrierService;
        const isWillCall =
          SHIPPING_WILL_CALL === record.shippingInfo.carrierService;
        return (
          <Select
            defaultValue={defaultValue}
            showArrow={false}
            disabled
            onChange={(e) => {
              if (typeof shipmentMethodChangeHandler === 'function') {
                shipmentMethodChangeHandler({
                  id: rfqId || 0,
                  orgId,
                  qtySerialNumber,
                  body: {
                    shippingAdjusts: [
                      {
                        serialNumber: record.serialNumber,
                        carrierService: value[e]?.serviceName,
                        shipmentType: value[e]?.shipmentType,
                        carrierType: value[e]?.carrierType,
                        charge: isJobConfig
                          ? record.revxFreightCharge
                          : record.freightCost,
                      },
                      ...otherPayload(record.serialNumber),
                    ],
                  },
                });
              }
            }}
          >
            <Select.Option value={0} key={0}>
              {isSpecialDelivery || isWillCall ? (
                <>{record.shippingInfo.carrierService}</>
              ) : (
                <>
                  {`${record.shippingInfo.carrierService} - ${
                    record.shippingInfo.businessDaysInTransit || 1
                  } days - `}
                  <RevxMoney value={record.shippingCost || 0} />
                </>
              )}
            </Select.Option>
            {/* {value?.map((i, k) => {
              return (
                <Select.Option value={i.key} key={i.key}>
                  {isSpecialDelivery || isWillCall ? (
                    <>{i.serviceName}</>
                  ) : (
                    <>
                      {`${i.serviceName} - ${i.businessDaysInTransit} days - `}
                      {i.supplierCharge && (
                        <RevxMoney value={i.supplierCharge} />
                      )}
                    </>
                  )}
                </Select.Option>
              );
            })} */}
          </Select>
        );
      },
    },
    {
      title: 'Costs',
      dataIndex: 'freightCost',
      render: (v, record) => {
        // const selectedSvc = record.methods?.find((item) => item.selected);
        const isSpecialDelivery =
          SHIPPING_SPECIAL_DELIVERY === record.shippingInfo.carrierService ||
          SHIPPING_SUPPLIER_DELIVERY === record.shippingInfo.carrierService;

        const isBilledSeparately =
          record.shippingInfo.accountType ===
          ShippingAccountTypeEnum.ORGANIZATION;
        const charge = isJobConfig
          ? isBilledSeparately
            ? record.shippingCost
            : record.revxFreightCharge
          : record.freightCost;
        return (
          <>
            {isSpecialDelivery && !disabled ? (
              <RevxInputNumber
                size="small"
                value={charge}
                disabled={
                  record.shippingInfo.carrierService === SHIPPING_WILL_CALL
                }
                onChange={(e) => {
                  if (typeof shipmentMethodChangeHandler === 'function') {
                    shipmentMethodChangeHandler({
                      id: rfqId || 0,
                      orgId,
                      qtySerialNumber,
                      body: {
                        shippingAdjusts: [
                          {
                            serialNumber: record.serialNumber,
                            charge: e,
                            // carrierService: selectedSvc?.serviceName,
                            // shipmentType: selectedSvc?.shipmentType,
                            // carrierType: selectedSvc?.carrierType,
                            // readyDate: moment(e).format()
                          },
                          ...otherPayload(record.serialNumber),
                        ],
                      },
                    });
                  }
                }}
                prefix="$"
                precision={2}
              />
            ) : (
              <RevxMoney value={charge || 0} />
            )}
            {isBilledSeparately ? ` (billed separately)` : ''}
          </>
        );
      },
    },
  ];

  const isSpecialDelivery = useMemo(() => {
    return Boolean(
      resource?.find(
        (item) => item.shippingInfo.carrierService === SHIPPING_SPECIAL_DELIVERY ||
                  item.shippingInfo.carrierService === SHIPPING_SUPPLIER_DELIVERY 
      )
    );
  }, [resource]);

  const readyDate = useMemo(() => {
    if (isSpecialDelivery) {
      if (resource?.[0]?.readyDate) {
        return moment(resource?.[0]?.readyDate, moment.ISO_8601);
      } else {
        return undefined;
      }
    } else {
      return moment(
        resource?.[0]?.readyDate || resource?.[0]?.suggestReadyDate,
        moment.ISO_8601
      );
    }
  }, [isSpecialDelivery, resource]);

  return (
    <div className="common-shipping-method-container">
      <div className="top-bar">
        <div className="top-bar__radio">
          <div className="top-bar__split-info">
            <span
              style={{
                paddingRight: '6px',
              }}
            >
              <Trans i18nKey="rfq.supplier.readyDate"></Trans>:
            </span>
            {Boolean(resource?.[0]) ? (
              <DatePicker
                disabled={disabled}
                allowClear={false}
                size="small"
                defaultValue={readyDate}
                format={DEFAULT_DATE_FORMAT}
                value={readyDate}
                disabledDate={(d) =>
                  d &&
                  (Boolean(
                    resource?.[0].orderDate &&
                      d < moment(resource?.[0].orderDate)
                  ) ||
                    Boolean(
                      resource?.[0].expectedDeliveryDate &&
                        d > moment(resource?.[0].expectedDeliveryDate)
                    ))
                }
                onChange={async (e) => {
                  if (typeof shipmentMethodChangeHandler === 'function') {
                    shipmentMethodChangeHandler({
                      id: rfqId || 0,
                      orgId,
                      qtySerialNumber,
                      body: {
                        readyDate: moment(e).format(
                          RFQ_SHIPPING_DATE_FORMAT_LOCAL
                        ),
                        shippingAdjusts: (resource || []).map((item) => {
                          return {
                            serialNumber: item.serialNumber,
                            charge: item.freightCost,
                          };
                        }),
                      },
                    });
                  }
                }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="top-bar__split-info">
          {shippingTitle} for Quantity {quantityIndex + 1} :{' '}
          {formatNumberToThousandths(quantity)}
        </div>
      </div>
      <div className="table-content">
        <RevxTable<ShippingColumnsType>
          loading={loading}
          dataSource={resource}
          columns={columns}
          pagination={false}
          rowKey="serialNumber"
        />
      </div>
    </div>
  );
};

export default RevxSupplierShippingMethodTable;
